import { render, staticRenderFns } from "./UpgradeSuccess.vue?vue&type=template&id=1c2e1016&"
import script from "./UpgradeSuccess.vue?vue&type=script&lang=js&"
export * from "./UpgradeSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports